import React, { useState } from 'react';
import { colors, shadows, radii } from '../../theme';

const variants = {
  primary: { background: colors.gradient, color: '#fff', border: 'none', shadow: '0 6px 16px rgba(99,102,241,0.30)' },
  danger: { background: colors.danger, color: '#fff', border: 'none', shadow: '0 6px 16px rgba(225,29,72,0.25)' },
  success: { background: colors.success, color: '#fff', border: 'none', shadow: '0 6px 16px rgba(22,163,74,0.22)' },
  ghost: { background: colors.surface, color: colors.text, border: `1px solid ${colors.border}`, shadow: 'none' },
  soft: { background: colors.primarySoft, color: colors.primary, border: 'none', shadow: 'none' },
};

export default function Button({ children, variant = 'primary', size = 'md', loading, disabled, style, ...props }) {
  const [hover, setHover] = useState(false);
  const v = variants[variant] || variants.primary;
  const padding = size === 'sm' ? '7px 13px' : size === 'lg' ? '13px 26px' : '9px 18px';
  const fontSize = size === 'sm' ? 13 : size === 'lg' ? 16 : 14;
  const isDisabled = disabled || loading;

  return (
    <button
      disabled={isDisabled}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        background: v.background,
        color: v.color,
        border: v.border,
        padding, fontSize,
        borderRadius: radii.md,
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        opacity: isDisabled ? 0.6 : 1,
        fontWeight: 600,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 7,
        whiteSpace: 'nowrap',
        transition: 'transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease',
        transform: hover && !isDisabled ? 'translateY(-1px)' : 'translateY(0)',
        boxShadow: hover && !isDisabled ? (v.shadow !== 'none' ? v.shadow : shadows.sm) : (variant === 'ghost' || variant === 'soft' ? 'none' : v.shadow),
        filter: hover && !isDisabled && (variant === 'ghost' || variant === 'soft') ? 'brightness(0.97)' : 'none',
        ...style
      }}
      {...props}
    >
      {loading ? <span className="sf-spinner" /> : children}
    </button>
  );
}
